import { connect } from 'react-redux';

import { Category, ICategoryDispatchProps, ICategoryOwnProps, ICategoryStoreProps } from './Category';
import { IAppState, TThunkDispatch } from '../../../../store/';
import { changeActiveScreen, TActiveScreen } from '../../../../store/activeScreen';
import { IIsActiveCategoryParams, onCategoryToggle } from '../../../../store/categories';
import { getSubscriptionsList } from '../../../../store/subscriptions';

const mapStateToProps = (state: IAppState): ICategoryStoreProps => ({
  currentCategoryName: (state.subscriptions.data && state.subscriptions.data.categoryName) || null,
});

const mapDispatchToProps = (dispatch: TThunkDispatch): ICategoryDispatchProps => ({
  changeActiveScreen: (activeScreen: TActiveScreen) => dispatch(changeActiveScreen(activeScreen)),
  getSubscriptionList: (categoryName: string) => dispatch(getSubscriptionsList({ categoryName, replace: true })),
  onChange: (params: IIsActiveCategoryParams) => dispatch(onCategoryToggle(params)),
});

export const CategoryContainer = connect<ICategoryStoreProps, ICategoryDispatchProps, ICategoryOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Category);
